export default {"src":"/_next/static/media/mortgages.9cb334fc.svg","height":76,"width":75,"blurWidth":0,"blurHeight":0};